angular
  .module("ticketco/common/arena")
  //.controller('arenaItemTypesController', arenaItemTypesController)
  .component("arenaItemTypes", {
    require: {
      groupsCtrl: "^?arenaItemTypeGroups",
    },
    bindings: {
      itemTypes: "<",
      activeItemType: "<",
      trackingLinkUuid: "<",
      promocode: "<",
      onItemTypeClick: "&",
    },
    templateUrl: "arenaItemTypesComponent.html",
    controller: function arenaItemTypesController() {
      var self = this;
      var active;
      var idEq = R.propEq("id");
      var findById = R.converge(R.find, [
        R.pipe(R.nthArg(0), idEq),
        R.nthArg(1),
      ]);

      var activeItemAdapter = function (x) {
        return x;
      };

      var getSections = R.prop("sections");
      var gt0 = R.gt(R.__, 0);

      //   hasTickets :: Integer -> Boolean
      self.hasTickets = R.memoizeWith(
        R.prop("id"),
        R.pipe(getSections, R.any(R.propEq("has_available_tickets", true)))
      );

      //   hasSections :: Integer -> Boolean
      self.hasSections = R.pipe(getSections, R.length, gt0);

      //   isEnabled :: Object -> Boolean
      self.isEnabled = R.allPass([self.hasSections, self.hasTickets]);

      self.isActive = function (curId, id) {
        return curId === id;
      };

      self.getActive = function () {
        return active ? active.take() : undefined;
      };

      self.setActive = function (itemType) {
        if (itemType.enabled) {
          active.put(
            self.isActive(active.take(), itemType.id) ? undefined : itemType.id
          );
        }
        return active.take();
      };

      self.getClassName = function (itemType, curId) {
        return !itemType.enabled
          ? "tc-available-item-types--item__disabled"
          : self.isActive(curId, itemType.id)
          ? "tc-available-item-types--item__selected"
          : "tc-available-item-types--item";
      };

      /* Sections functionality */

      // isEnabledSection :: Object -> Boolean
      self.isEnabledSection = R.pipe(R.propEq("has_available_tickets", true));

      var localStore = {
        put: function (x) {
          self.onItemTypeClick &&
            self.onItemTypeClick({
              $itemType: x,
            });
          self.activeItemType = x;
        },
        take: function () {
          return self.activeItemType;
        },
      };

      var groupsStore = {
        put: function (x) {
          self.groupsCtrl.onItemTypeClick &&
            self.groupsCtrl.onItemTypeClick({
              $itemType: x,
            });
          self.groupsCtrl.setActive(x);
        },
        take: function () {
          return self.groupsCtrl.getActive();
        },
      };

      this.$onInit = function () {
        self.activeItemType = parseFloat(self.activeItemType);

        var activeAdapter = self.groupsCtrl ? groupsStore : localStore;
        active = activeItemAdapter(activeAdapter);

        self.items = R.pipe(
          R.map(function (itemType) {
            itemType.default = itemType.id === self.activeItemType;
            itemType.enabled = self.isEnabled(itemType);
            itemType.sections = itemType.sections.filter(self.isEnabledSection);
            return itemType;
          }),
          R.sortBy(R.pipe(R.prop("default"), R.not))
        )(self.itemTypes || []);

        // Activate item type if item is specified
        if (self.activeItemType) {
          active.put(self.activeItemType);
        }
      };
    },
  });
